import { getGlobalThat } from '@bcf-vanilla-ts-v1-shared/di/global-that';

type GlobalWithAppLang = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __APP_LANG__: string;
};

export function setAppLangSegment(lang: string): void {
  const globalAny: GlobalWithAppLang = getGlobalThat();
  globalAny['__APP_LANG__'] = lang;
}

export function getAppLangSegment(): string {
  const globalAny: GlobalWithAppLang = getGlobalThat();
  return globalAny['__APP_LANG__'];
}
